import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {BLUE, BLUE_LIGHTER} from 'ui-library/Colors';

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  disabled?: boolean;
  dataTestAttrs?: DataTestAttrs;
}

export default function Link(props: LinkProps): JSX.Element {
  return (
    <a
      // eslint-disable-next-line no-restricted-syntax
      {..._.omit(props, 'disabled', 'dataTestAttrs')}
      href={props.disabled ? null : props.href}
      onClick={props.disabled ? null : props.onClick}
      className={classNames(props.className, css(styles.link), props.disabled && css(styles.disabledLink))}
      {...getTestProps(props.dataTestAttrs)}
    >
      {props.children}
    </a>
  );
}

const styles = StyleSheet.create({
  link: {
    color: BLUE,
    fontSize: 13,
    ':hover': {
      textDecoration: 'none',
    },
    ':active': {
      textDecoration: 'none',
    },
    ':focus': {
      textDecoration: 'none',
    },
  },
  disabledLink: {
    color: BLUE_LIGHTER,
    cursor: 'not-allowed',
  },
});
